import React from 'react'
import PropTypes from 'prop-types'

import employees from '../../data/employees'

import Employee from '../../components/Employee'
import List from '../../components/List'
import Heading from '../../components/Heading'
import Phone from '../../components/Phone'
import { Grid, Col } from '../../components/Grid'

export default function Contact ({ who, title, children }) {
  const employee = employees.find(({ id }) => id === who)

  return (
    <Grid list>
      <Col>
        <Employee who={who} />
      </Col>
      <Col>
        <Heading medium>{title}</Heading>

        <p>{children}</p>

        <List>
          <li>Telefon: <a href={`tel:${employee.phone}`}><Phone>{employee.phone}</Phone></a></li>
          <li>Epost: <a href={`email:${employee.email}`}>{employee.email}</a></li>
        </List>
      </Col>
    </Grid>
  )
}

Contact.propTypes = {
  who: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/Contact/index.js